import React from 'react';
import { DropdownItem } from 'reactstrap';
import SweetAlert from 'react-bootstrap-sweetalert';
import IntlMessages from 'util/IntlMessages';
import ListRowImage from 'components/listRowImage';
import ListRowFavourite from 'components/ListRowFavourite';
import ListRowCheckbox from 'components/ListRowCheckbox';
import ListRowData from 'components/ListRowData';
import ListRowDropdown from 'components/ListRowDropdown';
import BusinessUnitAdd from '../../businessUnitAdd/index';

class BusinessUnitRow extends React.Component {
    constructor() {
        super();
        this.state = {
            menuState: false,
            addBusinessUnitState: false,
            deleteBusinessUnitCheck: false,
        };
    }

    onBusinessUnitOptionToggle = () => {
        this.setState({ menuState: !this.state.menuState });
    };
    onBusinessUnitClose = () => {
        this.setState({ addBusinessUnitState: false });
    };
    onDeleteBusinessUnit = (businessUnit) => {
        this.setState({ addBusinessUnitState: false });
        this.props.onDeleteBusinessUnit(businessUnit ?.id);
    };
    onEditBusinessUnit = () => {
        this.setState({ menuState: false, addBusinessUnitState: true });
    };

    render() {
        const { width, businessUnit, addFavouriteBusinessUnit, onBusinessUnitSelect, onSaveBusinessUnit, showBusinessUnitLoader } = this.props;
        const { menuState, addBusinessUnitState, deleteBusinessUnitCheck } = this.state;
        const { name, description, starred } = businessUnit;
        const options = [
            'Edit',
            'Delete',
        ];
        return (
            <div className="contact-item">
                <ListRowCheckbox selected={businessUnit.selected} onClick={() => { onBusinessUnitSelect(businessUnit); }} />
                <ListRowFavourite width={width} onClick={() => { addFavouriteBusinessUnit(businessUnit); }} starred={starred} />
                <ListRowImage width={width} data={businessUnit} />
                <ListRowData lineOne={name} lineTwoLeft={description} />
                <ListRowDropdown 
                    menuState={menuState}
                    toggle={this.onBusinessUnitOptionToggle.bind(this)}
                    options={options}
                    dropdownItems={options.map(option =>
                        <DropdownItem key={option} onClick={() => {
                            if (option === 'Edit') {
                                this.onEditBusinessUnit();
                            } else if (option === 'Delete') {
                                this.setState({ deleteBusinessUnitCheck: true });
                            }
                        }
                        }>
                            {option}
                        </DropdownItem>,
                    )}
                />
                <div>
                    {addBusinessUnitState &&
                        <BusinessUnitAdd
                            open={addBusinessUnitState}
                            businessUnit={businessUnit}
                            onSaveBusinessUnit={onSaveBusinessUnit}
                            onBusinessUnitClose={this.onBusinessUnitClose}
                            onDeleteBusinessUnit={this.onDeleteBusinessUnit}
                            showBusinessUnitLoader={showBusinessUnitLoader}
                        />
                    }
                </div>
                <SweetAlert show={deleteBusinessUnitCheck}
                    warning
                    showCancel
                    confirmBtnText={<IntlMessages id="button.yesDeleteIt" />}
                    cancelBtnText={<IntlMessages id="button.cancel" />}
                    confirmBtnBsStyle="danger"
                    cancelBtnBsStyle="default"
                    title={<span style={{ fontWeight: 'bold', color: 'grey', fontSize: '200%' }}><IntlMessages id="general.areYouSure" /></span>}
                    onConfirm={() => {
                        this.onDeleteBusinessUnit(businessUnit);
                        this.setState({ deleteBusinessUnitCheck: false });
                    }}
                    onCancel={() => {
                        this.setState({ deleteBusinessUnitCheck: false });
                    }}
                >
                    <IntlMessages id="businessUnit.deleteBusinessUnit" />
                </SweetAlert>
            </div>
        );
    }
}

export default BusinessUnitRow;


// WEBPACK FOOTER //
// ./components/Agile/businessUnit/businessUnitList/businessUnitRow/index.js